import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {AudienceSortType} from 'nutshell-graphql-types';
import type {
    GetAudiencesForPreferenceCenter as GetAudiencesForPreferenceCenterQuery,
    GetAudiencesForPreferenceCenterVariables as GetAudiencesForPreferenceCenterVariables,
    GetAudiencesForPreferenceCenter_audiences_edges_node as Audience,
} from 'nutshell-graphql-types';

import GET_AUDIENCES_FOR_PREFERENCE_CENTER from '../queries/get-audiences.graphql';

export const useGetAudiencesForPreferenceCenter = (
    sort: AudienceSortType
): {
    audiences: Audience[];
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetAudiencesForPreferenceCenterQuery,
        GetAudiencesForPreferenceCenterVariables
    >(GET_AUDIENCES_FOR_PREFERENCE_CENTER, {
        variables: {
            sort,
        },
        fetchPolicy: 'cache-and-network',
    });

    const audiences = data ? data.audiences : null;

    return {
        audiences: audiences && audiences.edges ? audiences.edges.map((edge) => edge.node) : [],
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
